import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import * as i1 from '@skyux/flyout';
import { SkyFlyoutModule } from '@skyux/flyout';
import { YCCommonModule } from '@yourcause/common';

class FlyoutModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FlyoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: FlyoutModule, imports: [CommonModule,
            YCCommonModule,
            SkyFlyoutModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FlyoutModule, imports: [CommonModule,
            YCCommonModule,
            SkyFlyoutModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FlyoutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        YCCommonModule,
                        SkyFlyoutModule
                    ],
                    providers: [],
                }]
        }] });

class FlyoutService {
    constructor(flyoutService) {
        this.flyoutService = flyoutService;
    }
    /**
     * Opens the Flyout
     *
     * @param component: Component that contains the flyout content
     * @param flyoutConfig: Flyout configuration
     * @param onNext: Function that fires when user clicks next
     * @param onPrevious: Functiont that fires when user clicks previous
     * @param resolveFlyout: Function to await to prepare the next or previous flyout
     * @returns a promise, resolving when the flyout is closed
     */
    async openFlyout(component, flyoutConfig = {}, onNext, onPrevious, resolveFlyout, onInitial) {
        if (!!this.flyout) {
            this.flyout = undefined;
        }
        let passed = true;
        if (!!onInitial) {
            passed = await onInitial(resolveFlyout);
        }
        if (passed) {
            return new Promise((resolve) => {
                this.flyout = this.flyoutService.open(component, flyoutConfig);
                this.flyout.iteratorNextButtonClick.subscribe(() => {
                    if (!!onNext) {
                        onNext(resolveFlyout);
                    }
                });
                this.flyout.iteratorPreviousButtonClick.subscribe(() => {
                    if (!!onPrevious) {
                        onPrevious(resolveFlyout);
                    }
                });
                this.flyout.closed.subscribe(() => {
                    this.flyout = undefined;
                    resolve();
                });
            });
        }
    }
    /**
     * Close the Current Flyout
     */
    closeFlyout() {
        this.flyoutService.close();
        this.flyout = undefined;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FlyoutService, deps: [{ token: i1.SkyFlyoutService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FlyoutService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FlyoutService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.SkyFlyoutService }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FlyoutModule, FlyoutService };
